<template>
  <div
    class="wf-relative"
    :class="! previewMode ? 'wf-border wf-border-transparent hover:wf-border-blue-300 wf-py-4 wf-pb-2 wf-px-1' : ''"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <EditorOptions
      parent="component"
      v-show="hover && ! previewMode"
      :options="menuOptions"
      :parentModule="parentModule"
    />
    <div
      :id="containerId"
      :class="elementClasses(classes('classes'), classes('customClasses'))"
      :style="elementStyles(styles('styles'))"
    >
      <i
        :id="id"
        :class="elementClasses(classes('iconClasses'), [content.class, content.icon])"
        :style="elementStyles(styles('iconStyles'))"
      />
    </div>
  </div>
</template>

<script>
  import EditorComponent from '../contracts/EditorComponent'
  export default EditorComponent.extend({
    computed: {
      containerId() {
        return this.$store.getters[`${this.module}/id`](this.element, 'containerId')
      },
    },
  })
</script>
